import { Theme } from "js/core/models/theme";
import ThemesAdapter from "js/core/storage/themesAdapter";

const SharedTheme = Theme.extend({
    root: "sharedThemes",
    ensurePersisted: true,

    createAdapter: function(options) {
        return new ThemesAdapter({ ...options, model: this });
    }
});

export { SharedTheme };
